import React from 'react';
import classnames from 'classnames';
export interface ListGroupSubheaderProps extends React.HTMLProps<HTMLElement> {
  className?: string;
  tag?: string;
}

const ListGroupSubheader: React.FunctionComponent<ListGroupSubheaderProps> = ({
  tag: Tag = 'h3',
  className = '',
  children,
  ...otherProps
}) => {
  return (
    // https://github.com/Microsoft/TypeScript/issues/28892
    // @ts-ignore
    <Tag
      className={classnames('mdc-list-group__subheader', className)}
      {...otherProps}
    >
      {children}
    </Tag>
  );
};

export default ListGroupSubheader;
